import { render, staticRenderFns } from "./CompanySettingView.vue?vue&type=template&id=2a3d87ac"
import script from "./CompanySettingView.vue?vue&type=script&lang=js"
export * from "./CompanySettingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3d87ac')) {
      api.createRecord('2a3d87ac', component.options)
    } else {
      api.reload('2a3d87ac', component.options)
    }
    module.hot.accept("./CompanySettingView.vue?vue&type=template&id=2a3d87ac", function () {
      api.rerender('2a3d87ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanySettingView.vue"
export default component.exports